import React from 'react';

import {
  VirtualizedListV2,
  IconButton,
  HighlightOffIcon,
} from '@gogame/components';

const PreviewPermissionList = ({
  options,
  onDelete,
  getOptionLabel,
  getOptionValue,
}) => {
  return (
    <VirtualizedListV2
      data={options}
      secondaryAction={({ id }) => (
        <IconButton
          edge={'end'}
          tooltip={'Remove'}
          icon={<HighlightOffIcon />}
          onClick={(e) => onDelete(e, { id })}
        />
      )}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
    />
  );
};

export default PreviewPermissionList;
